import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { setOtherConfig } from '../../reduxStates'

const useAllHooks = (publisher: string) => {
  const dispatch = useDispatch()
  const uniqueId = '98798'

  const [configs, setConfigs] = useState<string>('')

  useEffect(() => {
    if (Object.values(configs).length && publisher !== 'jass' && publisher !== 'schalttool') {
      const newPublisherConfig = configs
      dispatch(setOtherConfig(newPublisherConfig))
    }
  }, [dispatch, configs, publisher])

  return { uniqueId, configs, setConfigs }
}

export default useAllHooks
